import * as React from 'react'; // Do not remove
import { BaseReactComponent } from '@eastsideco/salvo-ts';

export abstract class ThemeReactComponent extends BaseReactComponent {
    abstract render(): JSX.Element;
}

